
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { ToolContainer } from "../../contents";

@Component({
  components: {
    ToolContainer,
  }
})
export default class BookmarkToolContainablePaneMixin extends Mixins() {
  get enableTabs(): any[] {
    return Enumerable.from([
      ToolContainer.Tabs.bookmark,
    ])
    .where(t => !!t)
    .toArray();
  }

  get bookmarkTab(): any {
    return ToolContainer.Tabs.bookmark;
  }
}
